export const ADMIN_AUDIT_REPORT_REQUEST_DATA =
  'auditReport/ADMIN_AUDIT_REPORT_REQUEST_DATA';
export const ADMIN_AUDIT_REPORT_RECEIVE_DATA =
  'auditReport/ADMIN_AUDIT_REPORT_RECEIVE_DATA';
